import ApiService from "@/common/api/api.service";


const Anexo2 = {
    listarValoresDebitados(id) {
        return ApiService.get(`ValorDebitado?anexo2Id=${id}`);
    },
    
    listarProjetos(id) {
        return ApiService.get(`ValorDebitado/projetos-dropdown?anexo2Id=${id}`);
    },

    salvar(form) {
        if(form.id)
            return ApiService.put(`ValorDebitado`, form);
        return ApiService.post(`ValorDebitado`, form);
    },

    deletar(id) {
        return ApiService.delete(`ValorDebitado`, { id });
    },

    listar( empresaId, ano, anoFim, mesInicio, mesFim, ) {
        return ApiService.get(`Anexo2?Ano=${ano}${anoFim ? `&AnoFim=${anoFim}` : ''}${mesInicio ? `&MesInicio=${mesInicio}` : ''}${mesFim ? `&MesFim=${mesFim}`: ''}&EmpresaId=${empresaId}`);
    }
}

export default Anexo2;
